import { render, staticRenderFns } from "./PartiesPage.vue?vue&type=template&id=a71f79e2"
import script from "./PartiesPage.vue?vue&type=script&lang=ts"
export * from "./PartiesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports